import type { AnchorProtocol, BaseBreakPointProtocol, CursorProtocol, VariableADTvalue } from '../../protocols'
import { BlockType } from '../Basic'
import { BaseBlock } from './BaseBlock'

export enum VideoFitType {
    cover = 'cover',
    'auto' = 'auto'
}
export interface VideoBlockConfig extends BaseBreakPointProtocol, AnchorProtocol {
    /** 视频比例 */
    ratio?: string
    /** 圆角 */
    radius: string
    /** 显示加载图标 */
    showLoading: boolean
    /** 静音 */
    isMute: boolean
    /** 视频控件 */
    isUsedVideoControl: boolean
    /** 循环播放 */
    isLoop: boolean
    /** 自动播放 */
    isAuto: boolean
    /** 恢复上次播放 */
    resumePlay?: boolean
    /** 布局 */
    fitType: VideoFitType
    /** 视频地址 */
    videoSource?: VariableADTvalue
    /** 开启流媒体 */
    isVideoQualityLimit?: boolean
    /** 视频封面 */
    cover?: VariableADTvalue
    cursor?: CursorProtocol
}

export abstract class VideoBlockAbstract extends BaseBlock {
    type = BlockType.video

    abstract override config: VideoBlockConfig
}
